import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate } from '../../utils/util';
import { SelectItem } from './ComponentsUI';
import LoadUnloadService from '../../services/LoadUnloadService';

const SelectRackTypeUI = (props) => {

    useEffect(() => {
        if (props.rackTypeList && props.rackTypeList?.length === 0) {
            props.loadMdrTypes();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (isNullOrEmpty(props.value)) {
            document.getElementById(props.id || "rackType").value = "";
        }
        // eslint-disable-next-line
    }, [props.value]);

    const onChangeData = (event) => {
        if (props.onChangeData) {
            const rackType = props?.rackTypeList.find(f => f.id === event.target.value)
            props.onChangeData(rackType)
        }
    }

    return (
        <SelectItem
            {...props}
            id={props.id || "rackType"}
            label="Vasilhame"
            placeHolder={translate('general:choose-one-option')}
            onChangeData={onChangeData}
            changeEvent="true"
            maxLength={5}
            data={props?.rackTypeList ? props.rackTypeList.map((i) => {
                return { id: i.id, text: i.code };
            }) : []} />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        rackTypeList: state.loadUnloadReducer.rackTypeList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadMdrTypes: (callback) => {
            dispatch(LoadUnloadService.getMdrTypes(callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectRackTypeUI));
